import { isUp, isDown } from '@/utils/viewSize';

const resolveOperationErrorText = (operationError, getters) => {
  if (operationError === 'TIME_EDITING_EXPIRED') {
    /**
     * Нельзя изменить данные менее, чем за 16 ч. до начала ...
     */
    return getters.i18n(
      'cant_edit_details_cc__helper',
      getters['$_order/getOrder'].contract.editingTimeMin / 60,
    );
  }
};

export default {
  appIsReady: state => Object.keys(state.translations.translations).length,
  viewSize: state => viewCode => state.viewSize === viewCode,
  viewSizeUp: state => viewCode => isUp(state.viewSize, viewCode),
  viewSizeDown: state => viewCode => isDown(state.viewSize, viewCode),
  lang: state => state.lang,
  hasGlobalError: state => state.globalError,
  operationError: (state, getters) => resolveOperationErrorText(state.operationError, getters),
};



// WEBPACK FOOTER //
// ./src/store/getters.js